import { View, ViewProps } from "./view.tsx";

/** MAIN **/

export function Kbd(
  props: ViewProps<"kbd"> & {
    color?: string;
  },
) {
  const { color = "gray-500", ...viewProps } = props;
  return (
    <View tag="kbd">
      <View
        viewProps={viewProps}
        tag="span"
        class={[
          "flex items-center justify-center h-5 px-1 font-mono text-[0.6rem]",
          "rounded-md",
          "opacity-70 dark:opacity-70",
          `border-1 border-${color} text-${color} shadow-sm`,
        ]}
      />
    </View>
  );
}
